import type { SxProps } from '@mui/material';
import { Box, SlotBox } from '@packages/shared';
import type { ReactNode } from 'react';

export type SlotBoxDVProps = {
  mode: 'slotbox' | 'headline' | 'seo';
  children: ReactNode;
};

function getSxByMode(mode: SlotBoxDVProps['mode']): SxProps {
  switch (mode) {
    case 'headline': {
      return { px: [1.5, 1.5, 2] };
    }
    case 'seo': {
      return { px: [1.5, 1.5, 0] };
    }
    case 'slotbox':
    default: {
      return { p: [1.5, 1.5, 2], pb: [1.5, 1.5, 2] };
    }
  }
}

export const SlotBoxDV = ({ children, mode }: SlotBoxDVProps) =>
  mode === 'slotbox' ? (
    <SlotBox sx={getSxByMode(mode)}>{children}</SlotBox>
  ) : (
    <Box sx={getSxByMode(mode)}>{children}</Box>
  );
